<template>
    <div class="scroll-to-top" v-if="showButton" @click="scrollToTop">
        <button class="btnS">Subir <img src="/static/img/up.svg" alt="btn-up"></button>
    </div>
</template>

<script>
function data() {
	return {
		showButton: true,
	};
}

export default {
	data,
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			const scrollHeight = document.documentElement.scrollHeight;
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const clientHeight = document.documentElement.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight) {
				this.showButton = true;
			} else {
				this.showButton = true;
			}
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
	},
	props: {
		buttonText: {
			type: String,
			default: 'Subir',
		},
	},
};
</script>

<style lang="scss" scoped>
.scroll-to-top {
  position: fixed;
  bottom: 50px;
  right: 50px;
}

.btnS {
	background-color: color(orange-light);
	color: color(white);
	padding: 5px 15px;
	font-size: size(xlarge);
	font-weight: bold;
	border-radius: 20px;
	display: flex;
	img{
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: end;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/evaluation/btn-float.vue